import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NamedField } from '@shared/interfaces/field.interface';
import { FormArray, FormGroup } from '@angular/forms';
import { FieldBase } from './field-base';

@Component({
  selector: 'app-text-field',
  template: `
    <ng-container [formGroup]="group">
      <mat-label class="field__label" *ngIf="field.label">{{ field.label | translate }}</mat-label>
      <mat-form-field class="field__group d-block w-100" appearance="outline">
        <div *ngIf="field.prefix" matPrefix (click)="prefixClick.emit($event)">
          <ng-container #prefixRef></ng-container>
        </div>
        <input
          matInput
          class="field__input"
          #element
          [id]="field.name + '_' + uuid"
          [formControl]="group.get(field.name)"
          type="text"
          [placeholder]="field.placeholder | translate"
        />
        <div *ngIf="field.suffix" matSuffix (click)="suffixClick.emit($event)">
          <ng-container #suffixRef></ng-container>
        </div>
        <button
          mat-icon-button
          *ngIf="field.inputs?.type === 'search'"
          matSuffix
          class="btn--small text-400"
          (click)="
            suffixClick.emit($event) ||
              (!!group?.value[field.name] && group.get(field.name).setValue(''))
          "
        >
          <mat-icon *ngIf="group?.value[field.name]" class="icon icon--xsmall">clear</mat-icon>
          <app-icon  *ngIf="!group?.value[field.name]" class=" " size="xs" name="search"></app-icon>
        </button>
        <mat-error *ngIf="errors.length" class="field__error">
          <app-field-errors [errors]="errors"></app-field-errors>
        </mat-error>
      </mat-form-field>
    </ng-container>
  `,
  host: { class: 'field' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextFieldComponent extends FieldBase {
  @Input() field: NamedField;
  @Input() group: FormGroup | FormArray;
  @ViewChild('element') element: ElementRef;
}
